import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { BASE_PATH } from '../variables';
import { Configuration } from '../configuration';
import { ResponseModel } from '@core/api';
import { DeferredUpdateModel } from '../model/deferredUpdateModel';
import { DeferredUpdateBaseModel } from '../model/deferredUpdateBaseModel';
import { PaginationModel } from '../model/paginationModel';



@Injectable()
export class DeferredUpdateService {

  public configuration = new Configuration();
  public defaultHeaders = new HttpHeaders();
  protected basePath = 'https://localhost/v1';

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   *
   * Returns a list of deferred updates
   */
  public deferredUpdateGetAll(body: HttpParams): Observable<ResponseModel<DeferredUpdateBaseModel[], PaginationModel>> {
    return this.httpClient.get<ResponseModel<DeferredUpdateBaseModel[]>>(`${this.basePath}/deferred-changes`,
      {
        params: body
      }
    )
  }

  /**
  *
  * Returns a deffered update
  * @param id Get deferred update
  */
  public deferredUpdateGet(id: number): Observable<ResponseModel<DeferredUpdateModel>> {

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deferredUpdateIdDelete.');
    }

    return this.httpClient.get<ResponseModel<DeferredUpdateModel>>(`${this.basePath}/deferred-changes/${encodeURIComponent(String(id))}`);
  }

  /**
   *
   * Create deferrent update
   * @param body
   */
  public deferredUpdateCreatePost(body: DeferredUpdateModel): Observable<ResponseModel<DeferredUpdateModel>> {

    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling deferredUpdatePost.');
    }
    return this.httpClient.post<ResponseModel<DeferredUpdateModel>>(`${this.basePath}/deferred-changes`,
      body
    );
  }

  /**
 *
 * Update deferrent update
 * @param body
 */
  public deferredUpdateUpdatePatch(body: DeferredUpdateModel, id: number): Observable<ResponseModel<DeferredUpdateModel>> {

    if (body === null || body === undefined) {
      throw new Error('Required parameter body was null or undefined when calling deferredUpdateUpdatePatch.');
    }
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deferredUpdateUpdatePatch.');
    }
    return this.httpClient.patch<ResponseModel<DeferredUpdateModel>>(`${this.basePath}/deferred-changes/${encodeURIComponent(String(id))}`,
      body
    );
  }

  /**
 *
 * Delete a deffered update
 * @param id Get deferred update
 */
  public deferredUpdateIdDelete(id: number): Observable<ResponseModel<null>> {

    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deferredUpdateIdDelete.');
    }

    return this.httpClient.delete<ResponseModel<null>>(`${this.basePath}/deferred-changes/${encodeURIComponent(String(id))}`);
  }


}
